<template>
  <div class="courselist">
    <div class="banner_container">
      <div class="banner_title">开放课程</div>
      <img
        src="~@/assets/images/listitem/pic-banner-course@2x.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="container_wrap">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="eltab"
      >
        <el-tab-pane
          :label="item2.name"
          :name="item2.name"
          v-if="index2!=2"
          v-for="(item2, index2) in firstNav" 
          :key="index2"
        >
          <div
            class="tabpane_container coursor_plan_container"
            v-if="!item2.desc"
          >
            <div class="tabpane_container_title"  
            v-if="activeName != '课程教材(隐藏)'" 
          >
              <div
                class="container_title_item"
                v-for="(item, index) in secretaryTitleList"
                :key="index"
                :class="item.class"
                @click="secretarySortSelect(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div
              class="tabpane_container_title"
              v-if="activeName == '课程教材(隐藏)'"
            > 
              <!-- <div
                class="container_title_item"
                v-for="(item, index) in secretaryTitleListForth"
                :key="index"
                :class="item.class"
                @click="videoOrTextChooseFun(item)"
              >
                {{ item.name }}
              </div> -->
              <!-- 816
               <div
                class="container_title_item"
                v-for="(item, index) in forthNavList"
                :key="index"
                :class="item.class"
                @click="forthNavClickFun(index, item)"
              >
                {{ item.name }}
              </div> -->
            </div>
            <div class="search_line">
              <el-input
                placeholder="请输入内容"
                v-model="courseListfetchParams.keywords"
                clearable
                class="container_right_search"
                prefix-icon="el-icon-search"
                @keypress.native.enter="searchFun"
              ></el-input> 
              <div
                class="search_line_level"
                v-rblink="{ name: 'KaojiApplyStep1' }"
              >
                我要考级
              </div>
            </div>
            <div class="container_list"> 
              <template v-if="courseList.length">
                <!-- 1  处理课程教材(隐藏) -->
                <template v-if="activeName == '课程教材(隐藏)'">
                  
                <img
                          src="~@/assets/images/listitem/course_constuct.png"
                          class="list_empty_img_class"
                        />
                  <!--
                  <template v-for="(item, index) in courseList">
                     
                    <div
                      v-if="!forthNavFlagIndex || forthNavFlagIndex == 1"
                      class="container_list_item"
                      :key="index"
                      @click="specialCourseItemClick(item, 1)"
                    >
                      <div class="list_item_pic">
                        <div class="list_item_pic_tag">图文教111程</div>
                        <img :src="item.pic_url" />
                      </div>
                      <div class="list_item_title">{{ item.title }}</div>
                      <div class="list_item_bottom_study">
                        {{ item.views_count ? item.views_count : 0 }}人学习
                      </div>
                      <div class="list_item_bottom_free">免费</div>
                    </div>
                    <div
                      class="container_list_item"
                      :key="index + 'a'"
                      @click="specialCourseItemClick(item, 2)"
                      v-if="!forthNavFlagIndex || forthNavFlagIndex == 2"
                    >
                      <div class="list_item_pic">
                        <div class="list_item_pic_tag">示范视频</div>
                        <img :src="item.pic_url" />
                      </div>
                      <div class="list_item_title">{{ item.title }}</div>
                      <div class="list_item_bottom_study">
                        {{ item.views_count ? item.views_count : 0 }}人学习
                      </div>
                      <div class="list_item_bottom_free">免费</div>
                    </div>
                  </template>-->

                  <!-- <div
                    class="container_list_item"
                    v-for="(item, index) in courseList"
                    :key="index"
                    @click="courseItemClick(item)"
                  >
                    <div class="list_item_pic">
                      <div class="list_item_pic_tag">
                        {{ item.content_type == 1 ? "图文教程" : "示范视频" }}
                      </div>
                      <img :src="item.pic_url" />
                    </div>
                    <div class="list_item_title">{{ item.title }}</div>
                    <div class="list_item_bottom_study">
                      {{ item.views_count ? item.views_count : 0 }}人学习
                    </div>
                    <div class="list_item_bottom_free">免费</div>
                  </div> -->
                </template>
                <!-- 2非课程教材(隐藏)（课程教材、课后习题） -->
                <div
                  v-else
                  class="container_list_item"
                  v-for="(item, index) in courseList"
                  :key="index"
                  @click="courseItemClick(item)"
                >
                  <div class="list_item_pic">
                    <div
                      class="list_item_pic_tag list_item_pic_tag_outline"
                    >
                      图文
                    </div>
                    <!-- <template v-else>
                      <div
                        class="list_item_pic_tag"
                        v-if="activeName != '课后习题'"
                      >
                        {{ item.content_type == 1 ? "图文教程" : "示范视频" }}
                      </div>
                    </template> -->
                    <img :src="item.pic_url" />
                  </div>
                  <div class="list_item_title">{{ item.title }}</div>
                  <div class="list_item_bottom_study">
                    {{ item.views_count ? item.views_count : 0 }}人学习
                  </div>
                  <div class="list_item_bottom_free">免费</div>
                </div>
              </template>
              <template v-else>
                <img
                  src="~@/assets/images/listitem/course_constuct.png"
                  class="courselist_empty_img"
                />
              </template>
            </div>
          </div>
          <div class="tabpane_container tabpane_container_htm" v-else>
            <span
              v-html="courseplan"
              style="width: 1240px"
              class="htm_content html-data-table"
            ></span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <DeBounce
      :fetch-fun="DeBounceFetchData"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>
<script>
import MemberListItem from "@/components/listItem/MemberListItem";
import DeBounce from "@/components/DeBounce";
export default {
  name: "CmsCate",
  data() {
    return {
      activeName: "课程计划",
      firstNav: [{ name: "" }], //第er级导航
      secretaryTitleList: [
        //第三级导航
        {
          name: "全部",
          class: "container_title_item_active",
          content_type: "",
        },
      ],
      //课程教材(隐藏) 第四级nav
      forthNavList: [
        {
          name: "全部",
          class: "container_title_item_active",
          content_type: "",
        },
        {
          name: "图文",
          class: "",
          content_type: 1,
        },
        {
          name: "示范视频",
          class: "",
          content_type: 2,
        },
      ],

      secretaryTitleListForth: [
        //课程计划页面  导航 四级
        {
          name: "全部",
          class: "container_title_item_active",
          content_type: "",
        },
        {
          name: "图文",
          class: "",
          content_type: 1,
        },
        {
          name: "示范视频",
          class: "",
          content_type: 2,
        },
      ],
      secretaryTitleListForth_init: [
        //课程计划页面  导航 四级
        {
          name: "全部",
          class: "container_title_item_active",
          content_type: "",
        },
        {
          name: "图文",
          class: "",
          content_type: 1,
        },
        {
          name: "示范视频",
          class: "",
          content_type: 2,
        },
      ],
      courseList: [], //课程列表
      courseplan: "", //课程计划
      courseListfetchParams: {
        pageNo: 1,
        pageSize: 20,
        keywords: "",
      },
      pagefetchflag: true,
    };
  },
  mounted() {
    this.getCoursePlan();
    this.getTeacherMaterialSortfun(0); //获取二级目录
    this.handleJumb();
  },
  computed: {
    forthNavFlagIndex() {
      var tempindex = 0;
      this.forthNavList.forEach((element, index) => {
        if (element.class != "") {
          tempindex = index;
        }
      });
      return tempindex;
    },
  },
  methods: {
    forthNavClickFun(index, item) {
      if (item.class != "") {
        return;
      }
      this.forthNavList.some((ele) => {
        if (ele.class != "") {
          ele.class = "";
        }
      });
      this.forthNavList[index].class = "container_title_item_active";
    },
    //获取内容
    DeBounceFetchData() {
      if (this.$route.query.id == "course-20") {
        return;
      }
      this.getCourseListByType(
        this.courseListfetchParams.type,
        this.courseListfetchParams.cate_id,
        this.courseListfetchParams.content_type
      );
    },
    // 初始进入页面后完成跳转
    handleJumb() {
      var outlineCouse = [9, 4, 5, 8, 15, 16, 1]; //教材
      var secondNav = this.$route.query.id
        ? this.$route.query.id.split("-")[1]
        : "";
      secondNav = parseInt(secondNav);
      if (secondNav == 20) {
        //课程计划
        this.getCoursePlan();
      } else if (secondNav >= 10 && secondNav <= 14) {
        this.activeName = "课程教材";
        this.getTeacherMaterialSortfun(10);
        this.getCourseListByType(2);
        this.handThirdNavGoin(secondNav);
      } else if (outlineCouse.includes(secondNav) || secondNav == 9) {
        this.activeName = "课程教材(隐藏)";
        this.getTeacherMaterialSortfun(9);
        this.getCourseListByType(1);
        this.handThirdNavGoin(secondNav);
      } else {
        this.activeName = "课后习题";
        this.getTeacherMaterialSortfun(9);
        this.getCourseListByType(1);
        this.handThirdNavGoin(this.$route.query['sub-id']);
      }
    },
    //处理 初始进入时 第三级显示及作用
    handThirdNavGoin(secondNav) {
      var that = this;
      setTimeout(function () {
        that.secretaryTitleList.some(function (item) {
          if (secondNav == item.id) {
            that.secretarySortSelect(item);
            return;
          }
        });
      }, 300);
    },
    //tab点击事件
    handleClick(val) {
      this.secretaryTitleListForth = [
        //课程计划页面  导航 四级
        {
          name: "全部",
          class: "container_title_item_active",
          content_type: "",
        },
        {
          name: "图文",
          class: "",
          content_type: 1,
        },
        {
          name: "示范视频",
          class: "",
          content_type: 2,
        },
      ];
      // console.log(this.secretaryTitleListForth);
      for (var i = 0; i < this.firstNav.length; i++) {
        if (this.activeName == this.firstNav[i].name) {
          this.$router.push({
            path: "/cate",
            query: { id: "course-" + this.firstNav[i].id },
          });
          if (this.firstNav[i].desc) {
            //没有desc
            this.getCoursePlan(); //课程计划 栏目
          } else {
            if (this.firstNav[i].id == 21) {
              this.getTeacherMaterialSortfun(9);
            } else {
              this.getTeacherMaterialSortfun(this.firstNav[i].id);
            }
          }
          if (this.activeName == "课程教材") {
            this.getCourseListByType(2, 10);
          } else if (this.activeName == "课程教材(隐藏)") {
            this.getCourseListByType(1, 9);
          } else if (this.activeName == "课后习题") {
            this.getCourseListByType(1, 9);
          }
          return;
        }
      }
    },
    //处理第三级tab选择点击
    secretarySortSelect(val) {
      for (let i = 0; i < this.secretaryTitleList.length; i++) {
        if (this.secretaryTitleList[i].class == "container_title_item_active") {
          this.secretaryTitleList[i].class = "";
        }
      }
      let valindex = this.secretaryTitleList.indexOf(val);
      this.secretaryTitleList[valindex].class = "container_title_item_active";

      if (this.activeName == "课程教材") {
        this.getCourseListByType(2, val.id);
      } else {
        //教材
        for (var i = 0; i < this.secretaryTitleListForth.length; i++) {
          if (this.secretaryTitleListForth[i].class != "") {
            if (this.secretaryTitleListForth[i].name == "全部") {
              this.getCourseListByType(1, val.id);
            } else if (this.secretaryTitleListForth[i].name == "图文") {
              this.getCourseListByType(1, val.id, 1);
            } else if (this.secretaryTitleListForth[i].name == "示范视频") {
              this.getCourseListByType(1, val.id, 2);
            }
          }
        }
      }
      if(this.activeName == "课后习题"){
        this.$router.push({ path: "/cate", query: { id: "course-21",'sub-id':val.id } });
      }else{
        this.$router.push({ path: "/cate", query: { id: "course-" + val.id } });
      }

    },
    //处理第四级点击事件
    videoOrTextChooseFun(val) {
      for (let i = 0; i < this.secretaryTitleListForth.length; i++) {
        if (
          this.secretaryTitleListForth[i].class == "container_title_item_active"
        ) {
          this.secretaryTitleListForth[i].class = "";
        }
      }
      let valindex = this.secretaryTitleListForth.indexOf(val);
      this.secretaryTitleListForth[valindex].class =
        "container_title_item_active";
      // console.log('val',val)
      if (this.secretaryTitleListForth[valindex].name == "全部") {
        this.secretaryTitleList.some((item) => {
          if (item.class != "") {
            this.getCourseListByType(1, item.id);
          }
        });
      } else if (this.secretaryTitleListForth[valindex].name == "示范视频") {
        this.secretaryTitleList.some((item) => {
          if (item.class != "") {
            this.getCourseListByType(1, item.id, 2);
          }
        });
      } else if (this.secretaryTitleListForth[valindex].name == "图文") {
        this.secretaryTitleList.some((item) => {
          if (item.class != "") {
            this.getCourseListByType(1, item.id, 1);
          }
        });
      }
    },
    //处理大纲/教材 栏目内容
    searchFun() {
      // this.$message({ type: "success", message: "searchFun" });
      this.courseListfetchParams.pageNo = 1;
      this.pagefetchflag = true;
      this.getCourseListByType(
        this.courseListfetchParams.type,
        this.courseListfetchParams.cate_id,
        this.courseListfetchParams.content_type
      );
    },
    // 教材/大纲内容
    /**
     * type==1 教材 / type==2 大纲
     * content_type==1 图文 / content_type==2 示范视频
     */
    getCourseListByType(type, cate_id = "", content_type = 0) {
      // http://api.eaechina.net/adminapi/course/courseList?pageNo=1&pageSize=50&keywords=&type=1
      var that = this;
      if (
        this.courseListfetchParams.cate_id != cate_id ||
        this.courseListfetchParams.type != type ||
        this.courseListfetchParams.content_type != content_type
      ) {
        this.courseListfetchParams.pageNo = 1;
        this.pagefetchflag = true;
      }
      this.courseListfetchParams.cate_id = cate_id;
      this.courseListfetchParams.type = type;
      this.courseListfetchParams.content_type = content_type;
      that.$api.get(
        "/api/course/courseList",
        this.courseListfetchParams,
        (res) => {
          if (this.courseListfetchParams.pageNo == 1) {
            that.courseList = res.data.list;
          } else {
            if (
              res.data.list &&
              res.data.list.length < this.courseListfetchParams.pageSize
            ) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            that.courseList = that.courseList.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.courseListfetchParams.pageNo += 1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    // 获取课程列表(全部)
    // getCourseList(cate_id) { // http://api.eaechina.net/api/course/courseList?cate_id=18
    //   const that = this;
    //   that.$api.get(
    //     "/api/course/courseList",
    //     {
    //       cate_id: cate_id, //18表示 课程计划-分类下的课程
    //     },
    //     (res) => {
    //       // this.$message.success("发送成功");
    //       that.courseList = res.data.list;
    //     },
    //     (r) => {
    //       that.$message.error(r.msg);
    //     }
    //   );
    // },
    //获取课程计划列表内容
    getCoursePlan() {
      const that = this;
      that.$api.get(
        "/api/course/catelist",
        {
          id: 20,
        },
        (res) => {
          that.courseplan = res.data[0].desc;
          // console.log("resres.....", res.data);
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    // 获取课程列表(示范视频/图文)
    getCourseListBycontentType(content_type, cate_id = 18) {
      // http://api.eaechina.net/api/course/courseList?cate_id=18
      const that = this;
      that.$api.get(
        "/api/course/courseListDiviedByType",
        {
          cate_id: cate_id, //18表示 课程计划-分类下的课程
          content_type: content_type,
        },
        (res) => {
          that.courseList = res.data.list;
          // console.log("that.newsListData",that.newsListData)
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    courseItemClick(val) {
      if (this.activeName == "课后习题") {
        this.$router.push({
          path: "/worksdetail",
          query: {
            id: val.id,
            course_cate_id: this.$route.query.id.split("-")[1],
          },
        });
        return;
      }

      this.$router.push({
        path: "/coursecontent",
        query: {
          id: val.id,
          course_cate_id: this.$route.query.id.split("-")[1],
        },
      });
    },
    specialCourseItemClick(val, content_type) {
      this.$router.push({
        path: "/coursecontent",
        query: {
          id: val.id,
          course_cate_id: this.$route.query.id.split("-")[1],
          content_type: content_type,
        },
      });
    },
    // 教材管理获取 教材分类
    getTeacherMaterialSortfun(parent_id) {
      // http://api.eaechina.net/api/course/catelist?parent_id=9
      const that = this;
      that.$api.get(
        "/api/course/catelist",
        {
          parent_id: parent_id, //9  为教材-课程教材(隐藏)id/10为课程教材id
        },
        (res) => {
          //处理第二级nav
          if (parent_id == 0) {
            that.firstNav = res.data;
            return;
          }
          //处理第三级nav
          var tempval = {};
          that.secretaryTitleList = [];
          res.data.find((item) => {
            tempval["name"] = item.name;
            tempval["class"] = "";
            tempval["parent_id"] = item.parent_id;
            tempval["id"] = item.id;
            that.secretaryTitleList.push(tempval);
            tempval = {};
          });
          tempval = {
            name: "全部",
            class: "container_title_item_active",
            parent_id: parent_id,
            id: parent_id,
          };
          that.secretaryTitleList.unshift(tempval);
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  components: {
    MemberListItem,
    DeBounce,
  },
};
</script>
<style scoped lang="scss">
.courselist_empty_img {
  width: 100%;
  object-fit: cover;
}
.courselist {
  min-height: 1283px;
  background: #f4faff;
}
.banner_container {
  max-height: 318px;
  width: 100%;
  background: #f4faff;
  position: relative;
  .banner_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1240px;
    font-size: 48px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 400;
    color: #ffffff;
  }
}
.container_wrap {
  background: #f4faff;
  padding-bottom: 20px;
}
/deep/.eltab {
  width: 1240px;
  margin: 0 auto;
  margin-top: -65px;
  /deep/.el-tabs__header {
    margin: 0;
    border: none;
    /deep/.el-tabs__nav-wrap {
      padding-left: 0;
      /deep/.el-tabs__nav-scroll {
        /deep/.el-tabs__nav {
          border: none;
          display: flex;
          align-items: flex-end;
          /deep/.el-tabs__item {
            box-shadow: none;
            width: 240px;
            height: 89px;
            background: #ff8d3a;
            box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
            border-radius: 32px 32px 0px 0px;
            font-size: 24px;
            font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
              "\5FAE\8F6F\96C5\9ED1";
            font-weight: 500;
            color: #ffffff;
            line-height: 89px;
            text-align: center;
            margin-right: 16px;
            border-left: none;
          }
          /deep/.is-active {
            height: 107px;
            line-height: 127px;
            background: #ffffff;
            color: #333333;
            box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
  /deep/.el-tabs__content {
    width: 1240px;
    min-height: 690px;
    // background: #ffffff;
    // box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    // border-radius: 0px 0px 48px 48px;
  }
  .coursor_plan_container {
    .tabpane_container_title {
      width: 1240px;
      height: 81px;
      line-height: 81px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      font-size: 24px;

      font-weight: 400;
      color: #666666;
      padding-left: 23px;
      overflow: hidden;
      .container_title_item {
        margin-right: 25px;
        overflow: hidden;
        display: inline-block;
        &:hover {
          cursor: pointer;
          color: #f56057;
        }
      }
      .container_title_item_active {
        color: #f56057;
      }
    }
    .search_line {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 24px 0;
      .container_right_search {
        width: 308px;
        height: 44px;
        /deep/.el-input__inner {
          height: 44px;
          border-radius: 22px;
        }
      }
      .search_line_level {
        width: 105px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #0091ff;
        border-radius: 18px;
        font-size: 14px;
        font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
          "\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #ffffff;
        &:hover {
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
    .container_list {
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      flex-wrap: wrap;
      font-size: 0;
      .container_list_item {
        width: 290px;
        height: 242px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        margin-bottom: 30px;
        transition: all 0.2s;
        margin-right: 26px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          cursor: pointer;
          transform: scale(1.01);
        }
        .list_item_pic {
          width: 290px;
          height: 148px;
          // background: pink;
          position: relative;
          .list_item_pic_tag {
            position: absolute;
            top: 0;
            left: 23px;
            width: 76px;
            height: 25px;
            line-height: 25px;
            background: #498805;
            text-align: center;
            font-size: 14px;

            font-weight: 400;
            color: #ffffff;
          }
          .list_item_pic_tag_outline {
            width: 56px;
          }
          img {
            width: 290px;
            height: 148px;
            object-fit: cover;
          }
        }
        .list_item_title {
          width: 100%;
          height: 32px;
          font-size: 18px;
          font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
            "\5FAE\8F6F\96C5\9ED1";
          font-weight: 500;
          color: #000000;
          line-height: 32px;
          margin-top: 5px;
          margin-left: 6px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .list_item_bottom_study {
          margin-left: 8px;
          margin-top: 17px;
          height: 32px;
          font-size: 14px;

          font-weight: 400;
          color: #666666;
          line-height: 32px;
        }
        .list_item_bottom_free {
          width: 68px;
          height: 31px;
          line-height: 31px;
          text-align: center;
          background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
          border-radius: 10px 0px 10px 0px;
          position: absolute;
          right: 0;
          bottom: 0;

          font-size: 18px;
          font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
            "\5FAE\8F6F\96C5\9ED1";
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
  .tabpane_container {
    .htm_content {
      > * {
        margin: 0 auto;
      }
    }
  }
  .tabpane_container_htm {
    padding-top: 40px;
    background: #ffffff;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.05);
    border-radius: 0 0 34px 34px;
  }
}

/deep/.eltab >>> .el-tabs__header >>> .el-tabs__nav-wrap {
  padding: 0;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll {
  overflow: auto;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  border: none;
  display: flex;
  align-items: flex-end;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  box-shadow: none;
  width: 230px;
  height: 89px;
  background: #ff8d3a;
  box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
  border-radius: 32px 32px 0px 0px;
  font-size: 24px;
  font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
    "\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: #ffffff;
  line-height: 89px;
  text-align: center;
  margin-right: 25px;
  border-left: none;
  margin-right: 16px;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  height: 107px;
  line-height: 127px;
  background: #ffffff;
  color: #333333;
  box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
}
// /deep/.eltab >>> .el-tabs__content {
//   width: 1240px;
//   min-height: 690px;
//   background: #ffffff;
//   box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
//   border-radius: 0px 0px 48px 48px;
// }
/deep/.eltab >>> .el-tabs__header {
  margin: 0;
  border: none;
}
</style>


// WEBPACK FOOTER //
// CourseList.vue?c2ce8700